<template>
    <section>
      <h4>Booker Daily</h4>
      <LoadingSpinner v-if="loading" />
  
      <!-- <div class="row flex-grow-1 overflow-auto my-4 px-2">   -->
      <div class="row my-4 px-2" v-if="!loading">  
      
        <!-- Tabla de datos -->
        <div class="col-md-12 w-100 mb-3 card p-2" v-if="!loading">
          <div class="mx-0 px-0 table-responsive">
            <Table
              class="mx-2 w-100"
              :headers="headers"
              :cols="cols"
              :data="users"
              :checkbox="false"
              :notselect="true"
              :model="model"
              >
            </Table>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import { clientsService, usersService } from "@/_services";
  import Table from "@/components/Common/Table.vue";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import moment from "moment";

  export default {
    name: 'BookerDaily',
    computed: {
      ...mapState({
        currentUser: (state) => state.authentication.user,
        isMenuCollapse: (state) => state.sidebar.isNavOpen,
        filtersSystem: (state) => state.campaigns.filtersSystem,
      }),
    },
  
    data() {
      return {
        users: [],
        orderDirection: 'desc',
        datePickerConfig: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          maxDate: moment().endOf("day"),
        },
        datePickerConfigEndDate: {
          format: "YYYY-MM-DD",
          useCurrent: false,
          maxDate: moment().endOf("day"),
        },
        range: {
          startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        filterMonth: moment().format("YYYY-MMM"),
        orderBy: 'closed_tasks', 
        filters: [],
        filterkey: 2233,
        ordersStatus: [],
        fieldsLoading: true,
        sort: "",
        dir: "",
        keyFilter: 1,
        searchFilter: {},
        oldQuery: "  ",
        orderStatus: 10,
        loading: true,
        typelist: 10,
        typelistPreparing: 10,
        filterColumn: [],        
        showEmptyImage: false,  
        captainkey: 112000,
        model: {
          imported: false,
          refreshlist: false,
          selectfirst: false,
          cantPerPage: 25,
          currentPage: 1,
        },
        cols: [
          [
            {
            value: "photo",
            type: "image",
            width: "25px"
            }
          ],            
          [
            {
              value: "name",
            },
          ],
          [
            {
              value: "clients",
              type: "isComponentAsync"
            },
          ],
          [
          {
            value: "user_bdr_status_id",
            value_label: "bdr_status_name",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Screening",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "2",
                label: "Onboarding",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "3",
                label: "Validated",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Level 1",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "5",
                label: "Booker Level 2",
                bgColor: "#FF8C00",
                textColor: "#FFFFFF",
              },
              {
                id: "6",
                label: "Booker Manager",
                bgColor: "#4B0082",
                textColor: "#FFFFFF",
              },
              {
                id: "7",
                label: "Stopped",
                bgColor: "#B22222",
                textColor: "#FFFFFF",
              },
              {
                id: "8",
                label: "Rejected",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "9",
                label: "Test",
                bgColor: "black",
                textColor: "#FFFFFF",
              },
              {
                id: "10",
                label: "Booker France",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "11",
                label: "Booker Hivy",
                bgColor: "yellow",
                textColor: "black",
              },
              {
                id: "14",
                label: "Props. Closing",
                bgColor: "#C6F505",
                textColor: "black",
              },
              {
                id: "15",
                label: "Booker Level 3",
                bgColor: "#279CF5",
                textColor: "#FFFFFF",
              },
              {
                id: "16",
                label: "Booker Level 4",
                bgColor: "#F5AD27",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "",
                bgColor: "white",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
          // [
          //   {
          //     value: "bdr_status_name",          
          //   },
          // ],
          [
            {
                value: "user_status",
                type: "itemBadge",
                class: "badge",
                colors: [
                {
                    id: 'active',
                    label: "Active",
                    bgColor: "#008000",
                    textColor: "#FFFFFF",
                },
                {
                    id: 'inactive',
                    label: "Inactive",
                    bgColor: "red",
                    textColor: "#FFFFFF",
                },              
            ],
          },
          ],                          
          [
            {
                value: "r1",
                type: "itemBadgeConditional",
                min: "min-r1",            
            },
          ],
          [
            {
              value: "r2",
              type: "itemBadgeConditional",
              min: "min-r2",
            },
          ],
          [
            {
              value: "r3",
              type: "itemBadgeConditional",
              min: "min-r3",      
            },
          ],
          [
            {
              value: "r4",
              type: "itemBadgeConditional",
              min: "min-r4",        
            },
          ],
          [
            {
              value: "r5",
              type: "itemBadgeConditional",
              min: "min-r5",
            },
          ],
          [
            {
              value: "r6",
              type: "itemBadgeConditional",
              min: "min-r6",        
            },
          ],
          [
            {
              value: "r7",
              type: "itemBadgeConditional",
              min: "min-r7",        
            },
          ],
          [
            {
              value: "r8",
              type: "itemBadgeConditional",
              min: "min-r8",                 
            },
          ],
          [
            {
              value: "r9",
              type: "itemBadgeConditional",
              min: "min-r9",
            },
          ],
          [
            {
              value: "r10",
              type: "itemBadgeConditional",
              min: "min-r10",      
            },
          ],
          [
            {
              value: "r11",
              type: "itemBadgeConditional",
              min: "min-r11",       
            },
          ],          
          [
            {
              value: "meetings",
            },
          ],
          [
            {
              value: "ca_total",
            },
          ],
         
        ],
        ranges: [
            {
                id: 8,
                value: 'r1',                
            },
            {
                id: 9,
                value: 'r2',                
            },
            {
                id: 10,
                value: 'r3',                
            },
            {
                id: 11,
                value: 'r4',                
            },
            {
                id: 12,
                value: 'r5',                
            },
            {
                id: 13,
                value: 'r6',                
            },
            {
                id: 14,
                value: 'r7',                
            },
            {
                id: 15,
                value: 'r8',                
            },
            {
                id: 16,
                value: 'r9',                
            },
            {
                id: 17,
                value: 'r10',                
            },
            {
                id: 18,
                value: 'r11',                
            },
            {
                id: 19,
                value: 'r12',                
            },
            
        ],
        headers: [
          {
            label: 'Photo',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: 'Name',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: 'Clients',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: 'Role',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: 'Status',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },                 
          {
            label: '08 > 09',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["adminClients", "isBookerManager"], 
            id: 11,
          },
          {
            label: '09 > 10',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: '10 > 11',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '11 > 12',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '12 > 13',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '13 > 14',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '14 > 15',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '15 > 16',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '16 > 17',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '17 > 18',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: '18 > 19',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          },
          {
            label: 'Meetings',
            percentage: "10.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 1,
          },
          {
            label: 'Revenue',
            percentage: "5.5%",
            class: "overflowhide",
            permission: ["AgencyBilling", "isBookerManager"],
            id: 2,
          }, 
                
        ],
        intervalId: null,
      };
    },
    components: {
      Table,
      LoadingSpinner,
    },  
    mounted() {
        this.getData();      
        this.intervalId = setInterval(() => {
            this.getData()
        }, 300000)       
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    methods: {
      ...mapActions("headertopbar", {
        setCurrentRoute: "setRoute",
        setCurrentRouteChild: "setRouteChild",
      }),
  

      hasPermissions(perm) {
        return this.$store.getters["authentication/hasPermissions"](perm);
      },

      getData() {
        
        this.loading = true;        
             
        usersService.getBookerDaily()
          .then((res) => {
          if (res !== undefined) {

            let bookers = [];
            
            res.result.forEach((element) =>{
              if(element.has_avatar == "1"){
                let base64 = '';
                base64 = btoa(`usr-${element.id}`);
                element.photo = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
              }else{
                element.photo = require('@/assets/images/emptyperson.png');
              }
              bookers.push(element.id);
            })

            //configuro el minimo de cantidad de tareas solicitadas.
            //En el caso que la hora este registrada como hora en el que booker no trabaja entonces
            //el minimo se configura en 0 para que no se observe en rojo en la vista ese numero de tarea.
            res.result.map((item, index) => {
              this.ranges.forEach((range, index) => {
                  item['min-'+ range.value] = (Array.isArray(item.non_working_hours) && item.non_working_hours.includes(range.id)) ? 0 :11                
              })
              
            })
            
            //Ordeno data por status (activos y inactivos)
            const sortedData = res.result.sort((a, b) => {
                if (a.user_status < b.user_status) return -1;
                if (a.user_status > b.user_status) return 1;
                return 0;
            });

            this.users = sortedData

            const dataWithTotals = [
              ...this.users,
              {
                totalRow: true,
                id: 0,
                name: "Total",
                photo: '', //, require('@/assets/images/emptyperson.png'),
                clients: '', // this.users.reduce((acc, user) => acc + (user.clients ? user.clients.length : 0), 0),
                bdr_status_name: "",
                user_status: "",
                r1: this.users.reduce((acc, user) => acc + (Number(user.r1) || 0), 0),
                r2: this.users.reduce((acc, user) => acc + (Number(user.r2) || 0), 0),
                r3: this.users.reduce((acc, user) => acc + (Number(user.r3) || 0), 0),
                r4: this.users.reduce((acc, user) => acc + (Number(user.r4) || 0), 0),
                r5: this.users.reduce((acc, user) => acc + (Number(user.r5) || 0), 0),
                r6: this.users.reduce((acc, user) => acc + (Number(user.r6) || 0), 0),
                r7: this.users.reduce((acc, user) => acc + (Number(user.r7) || 0), 0),
                r8: this.users.reduce((acc, user) => acc + (Number(user.r8) || 0), 0),
                r9: this.users.reduce((acc, user) => acc + (Number(user.r9) || 0), 0),
                r10: this.users.reduce((acc, user) => acc + (Number(user.r10) || 0), 0),
                r11: this.users.reduce((acc, user) => acc + (Number(user.r11) || 0), 0),
                //r12: this.users.reduce((acc, user) => acc + (user.r12 || 0), 0),
                meetings: this.users.reduce((acc, user) => acc + (Number(user.meetings) || 0), 0),
                ca_total: this.users.reduce((acc, user) => acc + (Number(user.ca_total) || 0), 0),
                // has_avatar: "1",
                //photo: require('@/assets/images/emptyperson.png'),
                clients: [],
               
              },
            ];

            this.users = dataWithTotals // response.result;

            this.loading = false;            

           this.getAdditionalData(bookers);
          }
        });
      },      

      getAdditionalData(bookers) {
        clientsService.getClientsToBookers(bookers)
          .then((response) => {
            console.log("Response from getClientsToBookers:", response);
            this.users.forEach((user) => {
              const clients = response.result.filter(el => el.user_id == user.id);

              if(clients.length > 0 || user.user_bdr_status_id != '6') {
                user.clients = clients;
              } else {
                user.clients = 0;
              }              
            })
        });
    },
       
    },
  };
  </script>
  
  <style scoped>
  .banner {
    border-radius: 25em !important;
    color: #fff;
    font-size: 0.75em;
    text-align: left;
    margin-left: 1em;
    margin-right: 1em;
    margin-bottom: 0.2em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    background-color: #4d4deb;
    width: 98%;
  }
  
  .banner-message {
    margin-left: 2em;
    margin-right: 2em;
  }
  </style>
  